import ProductAttr from './product-attr';

export default ProductAttr;